import React, {ReactElement} from 'react'
import {Box, Dialog} from '@mui/material'
import {MainContainer} from '../../../../styledComponents/ContentsArea'
import {DisplayBlockDiv} from '../../../../styledComponents/DisplayItem'
import {CenterPlainLinkStyledButton, PrimaryStyledButton} from '../../../../styledComponents/Button'
import {Colors, FontSize, FontWeights} from '../../../../styledComponents/Constants'
import {Help} from '@mui/icons-material'
import {LeftRowFlexContainer} from '../../../../styledComponents/FlexComponents'
import styled from 'styled-components'
import {NavigateFunction} from 'react-router-dom'

interface Props {
    open: boolean
    handleCancelSetting: () => void
    navigate: NavigateFunction
}

class NatRegistrationDialogComponent extends React.Component<Props> {
    constructor(props: Props) {
        super(props)

        this.notRegistrationButtonClick = this.notRegistrationButtonClick.bind(this);
        this.useRegistrationButtonClick = this.useRegistrationButtonClick.bind(this);
    }

    // 長谷工ID登録に進む
    async useRegistrationButtonClick(): Promise<void> {
        this.props.navigate(`/resident/hasekoIdRegistration`)
    }

    // あとで登録する
    async notRegistrationButtonClick(): Promise<void> {
        this.props.handleCancelSetting();
    }

    render(): ReactElement {
        return (
            <>
                <Dialog
                    open={this.props.open}
                    fullWidth
                    maxWidth={'md'}
                >
                    <MainContainer>
                        <DialogTitle>
                            長谷工ID登録のお願い
                        </DialogTitle>
                        <Box height={'10px'}/>
                        <Box>
                            <Box fontSize={FontSize.Middle}>
                                素敵ネット利用規約の改定にともない、今後素敵ネットをご利用いただくためには、長谷工IDへの登録が必要となります。
                            </Box>
                            <Box height={'10px'}/>
                            <Box fontSize={FontSize.Small}>
                                <InfoArea>
                                    <Box p={'10px'}>
                                        <LeftRowFlexContainer>
                                            <Help style={helpIconStyle}/>長谷工IDとは
                                        </LeftRowFlexContainer>
                                        <Box height={'5px'}/>
                                        長谷工グループ内全体で利用可能な共通IDです。<br/>
                                        素敵ネットだけでなく、長谷工グループが提供しているポイントサービスや特典もご利用いただけます。
                                    </Box>
                                </InfoArea>
                            </Box>
                            <Box height={'30px'}/>
                        </Box>
                        <DisplayBlockDiv>
                            <PrimaryStyledButton onClick={this.useRegistrationButtonClick}>
                                長谷工ID登録に進む
                            </PrimaryStyledButton>
                            <Box height={'20px'}/>
                            <CenterPlainLinkStyledButton onClick={this.notRegistrationButtonClick}>
                                あとで登録する
                            </CenterPlainLinkStyledButton>
                        </DisplayBlockDiv>
                    </MainContainer>
                </Dialog>
            </>
        )
    }
}

export default NatRegistrationDialogComponent

const helpIconStyle = {
    fontSize: FontSize.Middle,
    color: Colors.AccentDark,
    marginRight: '3px',
}

const InfoArea = styled.div`
  background-color: ${Colors.Background};
  border-radius: 4px;
  white-space: pre-wrap;
`

const DialogTitle = styled.div`
  font-size: 16px;
  font-weight: ${FontWeights.Bold};
  color: ${Colors.AccentDark};
`
